import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'sales-credit-policies-approvers',
  storeModule.createStoreModule('sales-credit-policies-approvers')
)
